import { IconButton } from "@mui/material";
import { CloseSharp as CloseIcon } from "@mui/icons-material";
import { useStoreActions } from "easy-peasy";

export default function NotifierClose({ notificationKey }) {
  const closeSnackbar = useStoreActions(actions => actions.notifier.close);
  return (
    <div>
      <IconButton
        key="close"
        color="inherit"
        onClick={() => {
          closeSnackbar(notificationKey);
        }}
        size="large"
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
}
